import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType, FileType } from "@/common/types/common";
import type { CompanyPayloadType } from "@/common/types/company";

export async function companyList(account_id: string, query?: QueryType) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `account/${account_id}/company/list${queryString}`,
  );
}

export async function companyCreate(
  account_id: string,
  payload: CompanyPayloadType,
) {
  return await clientAxios.post(
    `account/${account_id}/company/create`,
    payload,
  );
}

export async function companyGet(account_id: string, company_id: string) {
  return await clientAxios.get(
    `account/${account_id}/company/${company_id}/show`,
  );
}

export async function companyUpdate(
  account_id: string,
  company_id: string,
  payload: CompanyPayloadType,
) {
  return await clientAxios.put(
    `account/${account_id}/company/${company_id}/update`,
    payload,
  );
}

export async function companyDel(account_id: string, company_id: string) {
  return await clientAxios.del(
    `account/${account_id}/company/${company_id}/delete`,
  );
}

export async function companyUpload(account_id: string, payload: FileType) {
  return await clientAxios.post(
    `account/${account_id}/company/upload`,
    payload,
  );
}

export async function companyModelCSV(account_id: string) {
  return await clientAxios.get(`account/${account_id}/company/csv/model`);
}
